<template>
    <div
        :class="context.classes.element"
        :data-has-files="hasFiles"
        :data-type="context.type">
        <FormulateSlot
            :context="context"
            name="prefix">
            <component
                :is="context.slotComponents.prefix"
                v-if="context.slotComponents.prefix"
                :context="context"/>
        </FormulateSlot>
        <div
            :class="context.classes.uploadArea"
            :data-has-files="hasFiles">
            <input
                ref="file"
                v-bind="attributes"
                v-on="$listeners"
                :data-is-drag-hover="isOver"
                type="file"
                @blur="context.blurHandler"
                @change="handleFile"
                @dragleave="handleDragLeave"
                @dragover="handleDragOver">
            <FormulateSlot
                :context="context"
                :has-files="hasFiles"
                name="uploadAreaMask">
                <component
                    :is="context.slotComponents.uploadAreaMask"
                    v-show="!hasFiles"
                    :class="context.classes.uploadAreaMask"
                    :data-has-files="context.slotComponents.uploadAreaMask === 'div' ? hasFiles : false"
                    :has-files="context.slotComponents.uploadAreaMask === 'div' ? false : hasFiles"/>
            </FormulateSlot>
            <FormulateFiles
                v-if="hasFiles"
                :context="context"
                :files="context.model"
                :image-preview="true"/>
        </div>
        <FormulateSlot
            :context="context"
            name="suffix">
            <component
                :is="context.slotComponents.suffix"
                v-if="context.slotComponents.suffix"
                :context="context"/>
        </FormulateSlot>

        <div v-if="cropperShow"
             class="modal d-flex"
             role="dialog"
             tabindex="-1">
            <div class="modal-dialog align-self-center"
                 role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">Bild zuschneiden</h5>
                        <button aria-label="Close"
                                class="close"
                                type="button"
                                @click="cropperHideModal">
                            <i class="fas fa-times"></i>
                        </button>
                    </div>
                    <div class="modal-body d-flex align-items-center">
                        <vue-cropper
                            ref="cropper"
                            :aspect-ratio="aspectRatio"
                            :src="cropperImgSrc"
                            alt="Source Image">
                        </vue-cropper>

                        <div class="cropper__controls position-absolute w-100 d-flex justify-content-between">
                            <button class="btn btn-primary mx-2"
                                    type="button"
                                    @click="cropperRotate(-90)"><i class="fas fa-undo"></i></button>

                            <button class="btn btn-primary mx-2"
                                    type="button"
                                    @click="cropperRotate(90)"><i class="fas fa-redo"></i></button>
                        </div>
                    </div>
                    <div class="modal-footer">
                        <button class="btn btn-primary"
                                type="button"
                                @click="cropperCropImage">Speichern <i class="fas fa-save"></i></button>
                        <button class="btn btn-secondary"
                                type="button"
                                @click="cropperHideModal">Abbrechen <i class="fas fa-times"></i></button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>


<script>
import FormulateInputMixin from '@braid/vue-formulate/src/FormulateInputMixin';
import FileUpload from '@braid/vue-formulate/src/FileUpload';
import FormulateFiles from '@braid/vue-formulate/src/FormulateFiles.vue';

export default {
    name: 'FormulateCropper',
    props: {
        context: {
            type: Object,
            required: true,
        },
        aspectRatio: Number,
    },
    components: {
        FormulateFiles,
    },
    mixins: [FormulateInputMixin],
    data() {
        return {
            isOver: false,
            cropperImgSrc: null,
            cropperShow: false,
            cropperReader: new FileReader(),
        };
    },
    computed: {
        hasFiles() {
            return !!(this.context.model instanceof FileUpload && this.context.model.files.length);
        },
    },
    created() {
        if (Array.isArray(this.context.model)) {
            if (typeof this.context.model[0][this.$formulate.getFileUrlKey()] === 'string') {
                this.context.model = this.$formulate.createUpload({
                    files: this.context.model,
                }, this.context);
            }
        }
    },
    mounted() {
        // Add a listener to the window to prevent drag/drops that miss the dropzone
        // from opening the file and navigating the user away from the page.
        if (window && this.context.preventWindowDrops) {
            window.addEventListener('dragover', this.preventDefault);
            window.addEventListener('drop', this.preventDefault);
        }
    },
    destroyed() {
        if (window && this.context.preventWindowDrops) {
            window.removeEventListener('dragover', this.preventDefault);
            window.removeEventListener('drop', this.preventDefault);
        }
    },
    methods: {

        cropperShowModal() {
            this.cropperShow = true;
        },

        cropperHideModal() {
            this.cropperShow = false;
        },

        cropperRotate(deg) {
            this.$refs.cropper.rotate(deg);
        },

        cropperCropImage() {
            // get image data for post processing, e.g. upload or setting image src
            let dataUrl = this.$refs.cropper.getCroppedCanvas().toDataURL(this.$refs.file.files[0].type, 0.9);
            let fileTitle = this.$refs.file.files[0].name;
            let newFile = this.dataURLtoFile(dataUrl, fileTitle);

            this.$refs.file.files = new this.FileListItems([newFile]);
            this.cropperHideModal();
            this.handleFurtherFile(this.$refs.file);
        },

        /**
         * https://stackoverflow.com/questions/52078853/is-it-possible-to-update-filelist
         */
        FileListItems(files) {
            let b = new ClipboardEvent('').clipboardData || new DataTransfer();
            for (let i = 0, len = files.length; i < len; i++) b.items.add(files[i]);
            return b.files;
        },

        preventDefault(e) {
            if (e.target.tagName !== 'INPUT' && e.target.getAttribute('type') !== 'file') {
                e = e || event;
                e.preventDefault();
            }
        },
        handleFile() {
            this.isOver = false;
            const input = this.$refs.file;
            if (input.files.length) {
                let file = input.files[0];
                if (file.type.indexOf('image/') === -1) {
                    this.$swal({
                        icon: 'error',
                        title: 'Bitte ein Bild auswählen',
                    });
                    return;
                }

                if (typeof FileReader === 'function') {
                    this.cropperReader.onload = (event) => {
                        this.cropperImgSrc = event.target.result;
                        // rebuild cropperjs with the updated source
                        this.$refs.cropper.replace(event.target.result);
                    };
                    this.cropperReader.readAsDataURL(file);
                    this.cropperShowModal();
                } else {
                    //FileReader API not supported, skip File Crop
                    this.handleFurtherFile(input);
                }
            }
        },

        handleFurtherFile(input) {
            this.context.model = this.$formulate.createUpload(input, this.context);
            // nextTick required for attemptImmediateUpload to pass instanceof reliably
            this.$nextTick(() => this.attemptImmediateUpload());
        },

        dataURLtoFile(dataUrl, filename) {
            let arr = dataUrl.split(','),
                mime = arr[0].match(/:(.*?);/)[1],
                bstr = atob(arr[1]),
                n = bstr.length,
                u8arr = new Uint8Array(n);
            while (n--) {
                u8arr[n] = bstr.charCodeAt(n);
            }
            return new File([u8arr], filename, {type: mime});
        },

        attemptImmediateUpload() {
            if (this.context.uploadBehavior === 'live' &&
                this.context.model instanceof FileUpload) {
                this.context.hasValidationErrors().then(errors => {
                    if (!errors) {
                        this.context.model.upload();
                    }
                });
            }
        },
        handleDragOver(e) {
            e.preventDefault();
            this.isOver = true;
        },
        handleDragLeave(e) {
            e.preventDefault();
            this.isOver = false;
        },
    },
};
</script>

<style scoped>
.modal-body {
    min-height: 500px;
}

.cropper__controls {
    left: 0;
    bottom: 10px;

}
</style>
